export default "__VITE_ASSET__CeSAPdlD__"